export function initJumpmarks(offset = 0) {

    function smoothScrollTo(elementId) {
        const element = document.getElementById(elementId);
        if (!element) return;

        const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth'
        });
    }

    if (window.location.hash) {
        window.scrollTo(0, 0);

        const elementId = window.location.hash.substring(1);
        if (elementId) {
            setTimeout(() => {
                smoothScrollTo(elementId);

                setTimeout(() => {
                    smoothScrollTo(elementId);
                }, 200);
            }, 300);
        }
    }

    document.addEventListener('click', function(e) {
        const link = e.target.closest('a');
        if (!link) return;

        const href = link.getAttribute('href');
        if (!href) return;

        if (link.closest('.modal')) return;

        let elementId = null;

        if (href.startsWith('#')) {
            elementId = href.substring(1);
        }
        else if (href.includes('#')) {
            try {
                const url = new URL(href, window.location.href);
                if (url.pathname === window.location.pathname) {
                    elementId = url.hash.substring(1);
                }
            } catch (err) {
                return;
            }
        }

        if (!elementId) return;

        e.preventDefault();
        e.stopPropagation();

        if (elementId === '') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (document.getElementById(elementId)) {
            smoothScrollTo(elementId);
        }
    }, true);
}